import { computePosition, autoUpdate, offset, flip, shift } from '@floating-ui/dom';

const OPENED_EVENT = 'table-dropdown:opened';

let instances = 0;

export default (placement = 'bottom-end') => ({
    open: false,

    cleanupPosition: null,

    uid: ++instances,

    onOtherOpened: null,

    init() {
        this.onOtherOpened = (event) => {
            if (event.detail?.uid !== this.uid) {
                this.close();
            }
        };

        window.addEventListener(OPENED_EVENT, this.onOtherOpened);
    },

    toggle() {
        this.open ? this.close() : this.show();
    },

    show() {
        // Only one dropdown at a time, so panels never stack on top of each other.
        window.dispatchEvent(new CustomEvent(OPENED_EVENT, { detail: { uid: this.uid } }));

        this.open = true;

        this.$nextTick(() => {
            this.cleanupPosition = autoUpdate(
                this.$refs.trigger,
                this.$refs.panel,
                () => this.updatePosition(),
            );
        });
    },

    close() {
        if (!this.open) {
            return;
        }

        this.open = false;

        this.stopPositioning();
    },

    updatePosition() {
        computePosition(this.$refs.trigger, this.$refs.panel, {
            placement,
            strategy: 'fixed',
            middleware: [offset(4), flip(), shift({ padding: 8 })],
        }).then(({ x, y }) => {
            Object.assign(this.$refs.panel.style, {
                position: 'fixed',
                left: `${x}px`,
                top: `${y}px`,
            });
        });
    },

    stopPositioning() {
        this.cleanupPosition?.();
        this.cleanupPosition = null;
    },

    destroy() {
        window.removeEventListener(OPENED_EVENT, this.onOtherOpened);

        this.stopPositioning();
    },
});
